import { computed } from 'vue';

const ACCOUNT_NUMBER_LENGTHS = [17, 26];
const CDV_MULTIPLICATION_NUMBERS = [9, 7, 3, 1, 9, 7, 3];

const getCdv = (accountNumberPart) => {
	let cdv = 0;
	CDV_MULTIPLICATION_NUMBERS.forEach((multiplicationNumber, index) => {
		cdv += accountNumberPart[index] * multiplicationNumber;
	});
	cdv = cdv.toString();
	cdv = cdv[cdv.length - 1] == 0 ? 0 : 10 - cdv[cdv.length - 1];
	return cdv;
};

export const useCdv = (accountNumber) => {
	const accountNumberParts = computed(() => accountNumber.value?.split('-'));
	const cdvNumbers = computed(() => {
		if (ACCOUNT_NUMBER_LENGTHS.includes(accountNumber.value?.length)) {
			const cdvs = accountNumberParts.value.map((part) => getCdv(part));
			return cdvs;
		}
		return null;
	});

	const cdvValid = computed(() => {
		if (ACCOUNT_NUMBER_LENGTHS.includes(accountNumber.value?.length)) {
			return accountNumber.value.startsWith('117') && accountNumberParts.value.every((part, index) => part[7] == cdvNumbers.value[index]);
		}
		return false;
	});
	return {
		cdvValid
	};
};
